export const APP = {
    'it.imprenditorevero.digital': {
        key: 'it.imprenditorevero.digital'
    }
}